
import React, { useState } from 'react'
import {AppGridBar,AppForm,AppGridTabs, AppTable} from 'qcc'
import { Row, Col} from 'antd';
import api from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'

let inputConfig = {
    example : {instructions:"此接口无需入参"} as any ,
    formdata:{} as any,
    labelWidth:100 ,
    items:
    [
        {lable:'说明：',field:'scene',placeholder:'此接口无需传参'},
    ]
} ;

let outputExample = {
    code: 200,
    msg: '',
    data:"834479135536"
} 

export interface Props{
    current?:string
}

export const AppGetChinaPayRefKey = (props:Props) =>{

    const[outputResult,setOutputResult]  = useState('' as string)
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let res = await api.posapp.getChinaPayRefKey();
        setOutputResult(res);
    }

    const renderOutput = () =>{
        if(outputResult===null) return '';
        switch(outputView){
            case 0:
            return renderJson();
        }

        return '';
    }

    const renderJson = () =>{
        return <pre>{JSON.stringify(outputResult, null, 4)}</pre>
    } 
    
    return (<div className='app-demo-content'>
            <h1>PosApp生成银联PayRefKey</h1>    
            <div>
                1、Pos端生成银联PayRefKey<br/>
                2、地址：/api/posApp/getChinaPayRefKey <br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent  config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={16} className='app-pos-api-input-form'>
                        {renderOutput()}
                    </Col>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>

            
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/posapi/app/AppGetChinaPayRefKey.tsx